import { Buffer } from 'buffer'

globalThis.Buffer = Buffer

window.global = globalThis
